<template>
  <div class="v2-layout-blog" @click.capture="onAppClick">
    <layout-header v-if="!loading" :menu-items="menuItems" />
    <div class="layout-container">
      <slot />
    </div>
    <template v-if="!loading">
      <blog-additional-content />
      <layout-footer :menu-items="menuItems" />
      <layout-footer-copyright />
      <modal-signup />
      <modal-login />
      <modal-forgot-password />
      <modal-age-approval />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useLayoutStore } from "@/store/layout";
import { useI18n } from "vue-i18n";
import LayoutHeader from "@/components/v2/layout-header/index.vue";
import LayoutFooter from "@/components/v2/layout-footer/index.vue";
import LayoutFooterCopyright from "@/components/v2/layout-footer-copyright/index.vue";
import BlogAdditionalContent from "@/components/v2/blog-additional-content/index.vue";
import { useAgeVerification } from "@/utils/ageVerification.ts";
import { useFeatureStore } from "@/store/feature.ts";

const ModalAgeApproval = defineAsyncComponent(() => import("@/components/v2/modals/modal-age-approval/index.vue"));
const ModalForgotPassword = defineAsyncComponent(() => import("@/components/v2/modals/modal-forgot-password/index.vue"));
const ModalSignup = defineAsyncComponent(() => import("@/components/v2/modals/modal-signup/index.vue"));
const ModalLogin = defineAsyncComponent(() => import("@/components/v2/modals/modal-login/index.vue"));

defineOptions({
  name: "layout-blog",
});

const layoutStore = useLayoutStore();
const featureStore = useFeatureStore();

const { t } = useI18n();

const menuItems = computed(() => {
  const items = [{ url: "/", anchor: t("Home"), name: "home" }];

  if (!featureStore.hasAgeVerificationFeature) {
    items.push({ url: "/blog", anchor: t("Blog"), name: "blog" });
  }

  items.push({ url: "#videos", anchor: t("Videos"), name: "videos" });
  items.push({ url: "#models", anchor: t("Models"), name: "models" });
  items.push({ url: "#reviews", anchor: t("Reviews"), name: "reviews" });
  return items;
});

const loading = computed(() => layoutStore.getPageLoading);
const { onAppClick } = useAgeVerification(loading);
</script>

<style lang="scss">
@import "./index.scss";
@import "~@/assets/v2/css/main.scss";
</style>
